module.exports = __webpack_public_path__ + "static/media/flag(ru).8b192c6f.svg";